/**
 * New features js
 */
;(function($) {
	function open_modal( replace_modal ) {
		var replace_modal = replace_modal ? true : false;
		var modal_id = get_modal_id();
		var focus_after_closed = this;
		var focus_when_open = undefined;
		var has_overlay_mask = false;
		var modal = get_modal();

		SUI[ replace_modal ? 'replaceModal' : 'openModal' ]( modal_id, focus_after_closed, focus_when_open, has_overlay_mask )

		return modal;
	}

	function get_modal_id() {
		return 'shipper-new-features';
	}

	function get_modal( id ) {
		return $( '#' + get_modal_id() );
	}

	function shipper_new_feature( e ) {
		e.preventDefault();

		var data = {
			action: 'shipper_new_features_modal_closed',
			_wpnonce: get_modal().find( '#shipper-got-it' ).data( 'nonce' )
		};

		$.post( ajaxurl, data )
			.always( function() {
				SUI.closeModal();
			})
	}

	function boot() {
		$( window ).on( 'load', function() {
			if ( get_modal().length ) {
				open_modal()
					.find( '#shipper-got-it' )
					.off( 'click' )
					.on( 'click', shipper_new_feature )
			}
		});
	}

	boot();
})(jQuery);
